export default function GlobalSafetyFooter() {
  return (
    <div
      style={{
        position: "sticky",
        bottom: 0,
        paddingBottom: 8, 
        fontSize: "0.75rem",
        textAlign: "center",
        background: "#fff",
        color: "#6b6b6b"
      }}
    >
      If your child is in immediate danger, seek emergency care.
    </div>
  );
}